<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-format-list-bulleted</v-icon>
                <p style="color: white;">Documentos por Validar</p>
                <v-spacer></v-spacer>
                <div v-if="loadingExcel == false">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab @click="DescargarExcel()">
                                <v-icon color="white" dark style="cursor: pointer !important" class="hover">
                                    mdi-file-excel-outline
                                </v-icon>
                            </v-btn>

                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </div>
                <v-progress-circular v-if="loadingExcel == true" color="white" indeterminate></v-progress-circular>
            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row v-if="showTable" justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlHistorial" :columns="columns" :params="displayInputs" :order="[]"
                                :formatterActions="formatterActions" @apiDT="apiDT = $event">
                            </DataTable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import MisPendientes from "@/services/Operacion/MisPendientes.service.js";
import Archivos from '@/services/Archivos/Archivos.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            showTable: false,
            nombreArchivo: '',
            showcargando: true,
            conclusion: false,
            urlHistorial: "MisPendientes/MisPendientesDocValidar",
            displayInputs: {

            },
            apiDT: null,
            columns: [

                { name: 'Reporte', data: 'Reporte', title: "Reporte", formatter: [this, "reporteForm"] },
                { name: 'TipoDocumento', data: 'TipoDocumento', title: "Tipo de documento" },
                { name: 'Cliente', data: 'Cliente', title: "Cliente" },
                { name: 'Flotilla', data: 'Flotilla', title: "Flotilla" },
                { name: 'Estado', data: 'Estado', title: "Estado" },
                { name: 'Asistencia', data: 'Asistencia', title: "Asistencia" }
            ],
            formatterActions: [
                { click: [this, "irDocumentos"] }
            ],

            listado: '',
            overlay: false,
            loadingExcel: false,
            nombreArchivo: '',
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {

        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        reporteForm(datos) {
            return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.Reporte}" aria-expanded="false"><span class='reporteindice'>${datos.Reporte}-${datos.Indice}</span></button></div>`;
        },
        async irDocumentos(params, item) {
            let reporte = {
                nrreporte: item.Reporte,
                svindice: item.Indice,
                aiclave: item.aiclave,
                svfhconclusion: ''
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
            window.open(this.$router.resolve({ name: "ArchivosExpJur" }).href, '_blank');
        },
        async DescargarExcel() {

            this.loadingExcel = true;
            const response = await MisPendientes.MisPendientesDocValidarExcel();
            let today = moment().format('yyyy-MM-DD');

            this.nombreArchivo = 'MisPendientesDocValidar-' + today.toString();

            await MetodosGenerales.exportToExcel(response, this.nombreArchivo, false, false);

            this.loadingExcel = false;

            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'MisPendientes');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'Mis Pendientes Documentos por Validar');
            formData.append("lanombre", this.nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            Archivos.AlmacenarVisitas(formData).then(data => {
            });
        },

    },

    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "343").then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });
    },

    async mounted() {
        this.showTable = true;
        this.showcargando = false;
        await this.reloadTable();
    }
}

</script>

<style>
.reporteindice {
    color: var(--v-anchor-base);
}
</style>
